module.exports = __webpack_public_path__ + "static/media/spaces_black.34e9f5df.svg";